/**
 * Filters criteria for refining query results
 */
export class FilterList {
    roles : Term[];
    disciplines : Term[];
    departments : Term[];
}
/**
 * Represents a term as defined by the API
 */
export class Term {
    count : number;
    name : string;
    label? : string;

    constructor(count: number, name: string, label?: string) {
        this.count = count;
        this.name = name;
        this.label = label;
    }

    get displayName(): string {
      return this.label?.trim() || this.name;
    }
}

/**
 * Defines a record for reporting purposes.
 */
export class ReportRecord {
    count : number;
    identifier : any;
    constructor(count: number, identifier: string) {
        this.count = count;
        this.identifier = identifier;
    }
}

/**
 * For time-related data, in this case number of events per time period.
 */
export class TimeData {
    count : number;
    time : number;
}

/**
 * The full response from the API
 */
export class AnalyticsData {
    publications : Term[];
    filters : FilterList;
    views : TimeData[];
}

/**
 * Defines the elements necessary to query the API for analytic data
 */
export class AnalyticsQuery {
    eventAction : string;
    temporal : string;
    role : string;
    discipline : string;
    department : string;
}

/**
 * Contains report configurations for csv output
 */
export class ReportConfig {
    headers : string[];
    title : string;
    constructor(headers : string[], title : string) {
        this.headers = headers;
        this.title = title;
    }
}

/**
 * Data structure for Google Analytics Reporting
 */
export class GAReporting {
  rows: string[];
  totalsForAllResults: number;
}

/**
 * Data structure for filters from 'Users Created' and 'References Added' report
 */
export class FilterReport {
    trend: string;
    roles: string[];
    areaOfFocus: string[];
    additionalProfileInformation: string[];
    dateFrom: number;
    dateTo: number;
}

/**
 * Data structure for response from 'Users Created' and 'References Added' report
 */
export class ResponseReport {
    rows: {string:number};
}
